
import { Service } from 'typedi';
import { Subject, Observable } from 'rxjs';


export class ScrollEvent {
    protected _distance: number;
    protected _isUp: boolean;
    protected _scrolledDistance: number;

    public get distance(): number {
        return this._distance;
    }
    public get scrolledDistance(): number {
        return this._scrolledDistance;
    }
    public get isUp(): boolean {
        return this._isUp;
    }

    constructor(
        distance: number, 
        isUp: boolean, 
        scrolledDistance: number) {
        this._distance = distance;
        this._isUp = isUp;
        this._scrolledDistance = scrolledDistance;
    }
}

@Service()
export default class Scroll {

    protected _scrollEvent: Subject<ScrollEvent>;
    protected scrollingDistance: number;

    constructor() {
        this._scrollEvent = new Subject();
        this.scrollControl(this._scrollEvent);
    }

    protected scrollControl(subject: Subject<ScrollEvent>): void {
        window.addEventListener(
            'scroll', 
            () => this.emitScrollEvent(subject), 
            { passive: true }
        );
    }

    protected updateScrollDistance(): number {
        const newScrollingDistance = window.pageYOffset || (document.documentElement || document.body.parentNode as any || document.body).scrollTop
        const scrollingOffset = newScrollingDistance - (this.scrollingDistance || 0);
        this.scrollingDistance = newScrollingDistance;
        return scrollingOffset;
    }

    protected emitScrollEvent(subject: Subject<ScrollEvent>): void {
        const distance = this.updateScrollDistance();
        const event = new ScrollEvent(distance, distance < 0, this.scrollingDistance);
        subject.next(event);
    }

    public get scrollEvent(): Observable<ScrollEvent> {
        return this._scrollEvent;
    }

}